import React, { useEffect, useRef, useState } from 'react';
import $image_url from 'js/utils/image_url';

interface Props {
  userId: number;
  displayName: string;
  profileImageUrl?: string;
  size?: string;
}

export default function RelatedAuthorProfileImage({
  userId,
  displayName,
  profileImageUrl,
  size = 's200',
}: Props) {
  const [imageSrc, setImageSrc] = useState<string>('');
  const [imageLoaded, setImageLoaded] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const imageUrl =
      profileImageUrl || $image_url(`/images/${size}_no_pic.png`);

    if (containerRef.current) {
      const parent = containerRef.current.parentElement;
      if (parent) {
        const ssrPlaceholder = parent.querySelector('.js-ssr-placeholder');
        if (ssrPlaceholder) {
          ssrPlaceholder.remove();
        }
      }
    }

    setImageSrc(imageUrl);
    setImageLoaded(true);
  }, [userId, profileImageUrl, size]);

  if (!imageLoaded) {
    return <div ref={containerRef} style={{ display: 'none' }} />;
  }

  return (
    <img
      ref={containerRef as any}
      src={imageSrc}
      className="profile-avatar u-positionAbsolute"
      alt={`${displayName} related author profile picture`}
      onError={() => {
        setImageSrc($image_url(`/images/${size}_no_pic.png`));
      }}
    />
  );
}
